var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 5.66667H14.5V4.33333C14.5 3.97971 14.3665 3.64057 14.129 3.39052C13.8915 3.14048 13.5693 3 13.2333 3H9.43333C9.09739 3 8.77521 3.14048 8.53766 3.39052C8.30012 3.64057 8.16667 3.97971 8.16667 4.33333V5.66667H5V7H6.26667V17C6.26667 17.5304 6.46684 18.0391 6.82316 18.4142C7.17948 18.7893 7.66276 19 8.16667 19H14.5C15.0039 19 15.4872 18.7893 15.8435 18.4142C16.1998 18.0391 16.4 17.5304 16.4 17V7H17.6667V5.66667ZM9.43333 4.33333H13.2333V5.66667H9.43333V4.33333ZM15.1333 17C15.1333 17.1768 15.0666 17.3464 14.9478 17.4714C14.8291 17.5964 14.668 17.6667 14.5 17.6667H8.16667C7.9987 17.6667 7.83761 17.5964 7.71883 17.4714C7.60006 17.3464 7.53333 17.1768 7.53333 17V7H15.1333V17Z",
    fill: "#26445A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7003 9.6665H9.43359V14.9998H10.7003V9.6665Z",
    fill: "#26445A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2335 9.6665H11.9668V14.9998H13.2335V9.6665Z",
    fill: "#26445A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/Remove.d08608a42865f14866f66a1beb11dcb6.svg";
export { ForwardRef as ReactComponent };